import {
  JOBSEEKER_LOGIN_REQUEST,
  JOBSEEKER_LOGIN_SUCCESS,
  JOBSEEKER_LOGIN_FAILURE,
  RESET_JOB,
} from "../../actionTypes";

export const loginRequest = (jobData) => ({
  type: JOBSEEKER_LOGIN_REQUEST,
  payload: jobData,
});

export const loginSuccess = (response) => ({
  type: JOBSEEKER_LOGIN_SUCCESS,
  payload: response,
});

export const loginFailure = (error) => ({
  type: JOBSEEKER_LOGIN_FAILURE,
  payload: error,
});

export const reset = () => ({
  type: RESET_JOB,
});
